let permissions = [];
let role = '';

export default {
  setRole: (userRole) => { role = userRole; },

  setPermissions: (newPermissions) => {
    if (Array.isArray(newPermissions)) {
      permissions = newPermissions;
    }
  },

  hasRole: thisRole => role === thisRole,

  can: candothis => permissions.includes(candothis),
};



// WEBPACK FOOTER //
// ./src/modules/auth.js